module.exports = __webpack_public_path__ + "img/submit1.d246b6b7.jpg";